<template>
  <div class="tickets-dashboard-summary">
    <div class="content-wrapper">
      <!-- Total Tickets -->
      <div class="content-items">
        <div class="content-title">Total Tickets</div>
        <div class="content-value">{{ tickets_dashboard_summary.total }}</div>
      </div>
      <!-- Open -->
      <div class="content-items">
        <div class="content-title">Open</div>
        <div class="content-value">{{ tickets_dashboard_summary.open }}</div>
      </div>
      <!-- Closed -->
      <div class="content-items">
        <div class="content-title">Closed</div>
        <div class="content-value">{{ tickets_dashboard_summary.closed }}</div>
      </div>
      <!-- Within SLA -->
      <div class="content-items">
        <div class="content-title">Within SLA</div>
        <div class="content-value">{{ tickets_dashboard_summary.within_sla }}</div>
      </div>
      <!-- SLA % -->
      <div class="content-items">
        <div class="content-title">SLA %</div>
        <div class="content-value">{{ tickets_dashboard_summary.within_sla_percentage }}%</div>
      </div>
      <!-- SLA Violation -->
      <div class="content-items">
        <div class="content-title">SLA Violation</div>
        <div class="content-value">{{ tickets_dashboard_summary.violation }}</div>
      </div>
      <!-- Violation % -->
      <div class="content-items">
        <div class="content-title">Violation %</div>
        <div class="content-value">{{ tickets_dashboard_summary.violation_percentage }}%</div>
      </div>
      <!-- Average Resolution Time -->
      <div class="content-items">
        <div class="content-title">Average Resolution Time</div>
        <div class="content-value capitalize">{{ tickets_dashboard_summary.average_rt }} Hrs</div>
      </div>
    </div>
  </div>
</template>

<script>
import ticketDashboardMixins from '../../../../../mixins/ticketDashboardMixins';
export default {
  name: "TicketsDashboardSummary",
  mixins: [ticketDashboardMixins]
}
</script>